import React, { useState, useEffect } from "react";
import Layout from "../components/Layout";
import axios from "axios";
import { baseURL } from "../Data/api";
import { TreeTable } from "primereact/treetable";
import { Column } from "primereact/column";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import loaderAnimation from '../assets/images/loader (2).json'; 
import Lottie from 'lottie-react';
import Cookies from 'js-cookie'
import { useNavigate } from "react-router-dom";
import './styles.css';
import * as XLSX from "xlsx"

const Dashboard = () => {
    const [drawWinner, setDrawWinner] = useState([]);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [serviceName, setServiceName] = useState('');
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [rows, setRows] = useState(25);

    const navigate = useNavigate();
    const username = Cookies.get('username');

    const checkuser = () => {
        if (!username) {
            navigate('/login');
        }
    }

    useEffect(() => {
        checkuser();
    }, []);

    const fetchData = async () => {
        if (!startDate || !endDate || !serviceName) {
            alert("Please select all fields");
            return;
        }

        setLoading(true);
        setSubmitted(true);
        try {
            const response = await axios.get(`${baseURL}/api/v1/subscription`, {
                params: {
                    startDate: startDate,
                    endDate: endDate,
                    serviceName: serviceName
                },
            });

            setDrawWinner(response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        fetchData();
    };

    const formatDate = (date, isEndDate = false) => {
        if (!date) return '';
        const time = isEndDate ? '23:59:59' : '00:00:00';
        return dayjs(date).format('YYYY-MM-DD') + ` ${time}`;
    };

    const downloadExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(drawWinner);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "SubscriptionData");
        XLSX.writeFile(workbook, "SubscriptionData.xlsx");
    };

    const isMyKidzHub = serviceName === 'MyKidzHub';

    return (
        <Layout>
            <div className="">
                <div className="flex justify-between">
                    <span className="font-semibold text-lg text-black">Subscription</span>
                </div>
            </div>

            <div className="flex justify-center items-center mt-3">
                <form onSubmit={handleSubmit} className="flex flex-col lg:flex-row gap-6 items-center bg-gray-100 p-6 rounded-lg shadow-lg w-full max-w-2xl">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <div className="flex flex-col lg:flex-row gap-4 w-full">
                            <div className="w-full text-black">
                                <label className="text-black">Service</label>
                                <select
                                    value={serviceName}
                                    onChange={(e) => setServiceName(e.target.value)}
                                    className="w-full p-4 border-zinc-400 hover:border-black rounded bg-gray-50 border">
                                    <option>Select Service</option>
                                    <option value="MyKidzHub">MyKidzHub</option>
                                    <option value="YoGamezPro">YoGamezPro</option>
                                    <option value="YoNumbers">YoNumbers</option>
                                    <option value="YoGamezXR">YoGamezXR</option>
                                </select>
                            </div>
                            <div className="w-full text-black">
                                <label>Start Date</label>
                                <DatePicker
                                    value={startDate ? dayjs(startDate) : null}
                                    onChange={(newValue) => setStartDate(formatDate(newValue))}
                                    format="YYYY-MM-DD"
                                    className="w-full"
                                />
                            </div>
                            <div className="w-full text-black">
                                <label>End Date</label>
                                <DatePicker
                                    value={endDate ? dayjs(endDate) : null}
                                    onChange={(newValue) => setEndDate(formatDate(newValue, true))}
                                    format="YYYY-MM-DD"
                                    className="w-full"
                                />
                            </div>
                        </div>
                    </LocalizationProvider>

                    <button type="submit" className="bg-blue-500 lg:mt-6 text-white p-2 rounded hover:bg-blue-400">
                        Submit
                    </button>
                </form>
            </div>

            {loading && (
                <div className="flex justify-center items-center w-full mt-10 lg:mt-4">
                    <Lottie animationData={loaderAnimation} style={{ width: 200, height: 200 }} />
                </div>
            )}

            {!loading && submitted && drawWinner.length === 0 && (
                <p className="text-center text-red-500 mt-10">No Data Found</p>
            )}

            {!loading && drawWinner.length > 0 && (
                <div className="overflow-x-auto mt-10 py-4">
                    <div className="flex justify-end mb-4">
                        <button onClick={downloadExcel} className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-400">
                            Download
                        </button>
                    </div>
                    <TreeTable
                        className="w-[400px] sm:w-[660px] md:w-[790px] lg:w-[980px]"
                        value={drawWinner.map((item, index) => ({
                            key: index.toString(),
                            data: { ...item, serialNumber: index + 1 }
                        }))}
                        paginator
                        rowsPerPageOptions={[25, 50, 75, 100]}
                        rows={rows}
                    >
                        <Column field="serialNumber" header="S.No" style={{ width: "60px" }}
                            body={(rowData) => rowData.data.serialNumber} />
                        <Column field="date" header="Date" style={{ width: "140px" }} />
                        <Column field="dailySubscription" header="Daily Subscription" style={{ width: "120px" }} />
                        <Column field="weeklySubscription" header="Weekly Subscription" style={{ width: "120px" }} />
                        <Column field="monthlySubscription" header="Monthly Subscription" style={{ width: "120px" }} />

                        {/* Bundle column — only for MyKidzHub */}
                        {isMyKidzHub && (
                            <Column field="bundle" header="Bundle" style={{ width: "120px" }} />
                        )}

                        <Column field="ussd" header="USSD" style={{ width: "120px" }} />
                        <Column field="web" header="WEB" style={{ width: "120px" }} />
                        <Column field="sms" header="SMS" style={{ width: "120px" }} />
                        <Column field="total" header="Total" style={{ width: "120px" }} />
                    </TreeTable>
                </div>
            )}
        </Layout>
    );
};

export default Dashboard;



// import React, { useState, useEffect } from "react";
// import Layout from "../components/Layout";
// import axios from "axios";
// import { baseURL } from "../Data/api";
// import { TreeTable } from "primereact/treetable";
// import { Column } from "primereact/column";
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import dayjs from 'dayjs';
// import loaderAnimation from '../assets/images/loader (2).json'; 
// import Lottie from 'lottie-react';
// import Cookies from 'js-cookie'
// import { useNavigate } from "react-router-dom";
// import './styles.css';
// import * as XLSX from "xlsx"

// const Dashboard = () => {
//     const [drawWinner, setDrawWinner] = useState([]);
//     const [startDate, setStartDate] = useState('');
//     const [endDate, setEndDate] = useState('');
//     const [serviceName, setServiceName] = useState('');
//     const [loading, setLoading] = useState(false);
//     const [submitted, setSubmitted] = useState(false);
//     const [rows, setRows] = useState(25);

//     const navigate = useNavigate();
//     const username = Cookies.get('username');

//     const checkuser = () => {
//         if (!username) {
//             navigate('/login');
//         }
//     }

//     useEffect(() => {
//         checkuser();
//     }, []);

//     const fetchData = async () => {
//         if (!startDate || !endDate || !serviceName) {
//             alert("Please select all fields");
//             return;
//         }
         
       

//         setLoading(true);
//         setSubmitted(true);
//         try {
//             const response = await axios.get(`${baseURL}/api/v1/subscription`, {
//                 params: {
//                     startDate: startDate,
//                     endDate: endDate,
//                     serviceName: serviceName
//                 },
//             });

//             setDrawWinner(response.data);
//         } catch (error) {
//             console.error("Error fetching data:", error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleSubmit = (e) => {
//         e.preventDefault();
//         fetchData();
//     };

//     const formatDate = (date, isEndDate = false) => {
//         if (!date) return '';
//         const time = isEndDate ? '23:59:59' : '00:00:00';
//         return dayjs(date).format('YYYY-MM-DD') + ` ${time}`;
//     };

//     const downloadExcel = () => {
//         const worksheet = XLSX.utils.json_to_sheet(drawWinner);
//         const workbook = XLSX.utils.book_new();
//         XLSX.utils.book_append_sheet(workbook, worksheet, "SubscriptionData");
//         XLSX.writeFile(workbook, "SubscriptionData.xlsx");
//     };

//     return (
//         <Layout>
//             <div className="">
//                 <div className="flex justify-between">
//                     <span className="font-semibold text-lg text-black">Subscription</span>
//                 </div>
//             </div>

//             <div className="flex justify-center items-center mt-3">
//                 <form onSubmit={handleSubmit} className="flex flex-col lg:flex-row gap-6 items-center bg-gray-100 p-6 rounded-lg shadow-lg w-full max-w-2xl">
//                     <LocalizationProvider dateAdapter={AdapterDayjs}>
//                         <div className="flex flex-col lg:flex-row gap-4 w-full">
//                             <div className="w-full text-black">
//                                 <label className="text-black">Service</label>
//                                 <select
//                                     value={serviceName}
//                                     onChange={(e) => setServiceName(e.target.value)}
//                                     className="w-full p-4 border-zinc-400 hover:border-black rounded bg-gray-50 border">
//                                 <option>Select Service</option>

//                                     <option value="MyKidzHub">MyKidzHub</option>
//                                     <option value="YoGamezPro">YoGamezPro</option>
//                                     <option value="YoNumbers">YoNumbers</option>
//                                  <option value="YoGamezXR">YoGamezXR</option>

                                    
//                                 </select>
//                             </div>
//                             <div className="w-full text-black">
//                                 <label>Start Date</label>
//                                 <DatePicker
//                                     value={startDate ? dayjs(startDate) : null}
//                                     onChange={(newValue) => setStartDate(formatDate(newValue))}
//                                     format="YYYY-MM-DD"
//                                     className="w-full"
//                                 />
//                             </div>
//                             <div className="w-full text-black">
//                                 <label>End Date</label>
//                                 <DatePicker
//                                     value={endDate ? dayjs(endDate) : null}
//                                     onChange={(newValue) => setEndDate(formatDate(newValue, true))}
//                                     format="YYYY-MM-DD"
//                                     className="w-full"
//                                 />
//                             </div>
//                         </div>
//                     </LocalizationProvider>

//                     <button type="submit" className="bg-blue-500 lg:mt-6 text-white p-2 rounded hover:bg-blue-400">
//                         Submit
//                     </button>
//                 </form>
//             </div>

//             {loading && <div className="flex justify-center items-center w-full mt-10 lg:mt-4">
//                 <Lottie animationData={loaderAnimation} style={{ width: 200, height: 200 }} />
//             </div>}

//             {!loading && submitted && drawWinner.length === 0 && <p className="text-center text-red-500 mt-10">No Data Found</p>}

//             {!loading && drawWinner.length > 0 && (
//                 <div className="overflow-x-auto mt-10 py-4">
//                     <div className="flex justify-end mb-4">
//                         <button onClick={downloadExcel} className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-400">
//                             Download
//                         </button>
//                     </div>
//                     <TreeTable
//                         className="w-[400px] sm:w-[660px] md:w-[790px] lg:w-[980px]"
//                         value={drawWinner.map((item, index) => ({
//                             key: index.toString(),
//                             data: { ...item, serialNumber: index + 1 }
//                         }))}
//                         paginator
//                         rowsPerPageOptions={[25, 50, 75, 100]}
//                         rows={rows}
//                     >
//                         <Column field="serialNumber" header="S.No" style={{ width: "60px" }}
//                             body={(rowData) => rowData.data.serialNumber}></Column>
//              <Column field="date" header="Date" style={{ width: "140px" }}></Column>
//          <Column field="dailySubscription" header="Daily Subscription" style={{ width: "120px" }}></Column>
//           <Column field="weeklySubscription" header="Weekly Subscription" style={{ width: "120px" }}></Column>
//          <Column field="monthlySubscription" header="Monthly Subscription" style={{ width: "120px" }}></Column>
//                         <Column field="ussd" header="USSD" style={{ width: "120px" }}></Column>
//                         <Column field="web" header="WEB" style={{ width: "120px" }}></Column>
//                         <Column field="sms" header="SMS" style={{ width: "120px" }}></Column>
//                          {/* Bundle column — only for MyKidzHub */}
//                         {isMyKidzHub && (
//                             <Column field="bundle" header="Bundle" style={{ width: "120px" }} />
//                         )}
//                         <Column field="total" header="Total" style={{ width: "120px" }}></Column>
//                     </TreeTable>
//                 </div>
//             )}
//         </Layout>
//     );
// };

// export default Dashboard;






// import React, { useState, useEffect } from "react";
// import Layout from "../components/Layout";
// import axios from "axios";
// import { baseURL } from "../Data/api";
// import { TreeTable } from "primereact/treetable";
// import { Column } from "primereact/column";
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import dayjs from 'dayjs';
// import loaderAnimation from '../assets/images/loader (2).json'; 
// import Lottie from 'lottie-react';
// import Cookies from 'js-cookie'
// import { useNavigate } from "react-router-dom";
// import './styles.css';
// import * as XLSX from "xlsx"
// // import {FaDownload} from 'react-icons/fa'
// // import { PiMicrosoftExcelLogoFill } from "react-icons/pi";


// const Dashboard = () => {
//     const [drawWinner, setDrawWinner] = useState([]);
//     const [startDate, setStartDate] = useState('');
//     const [endDate, setEndDate] = useState('');
//     const [loading, setLoading] = useState(false);
//     const [submitted, setSubmitted] = useState(false);
//     const [rows, setRows] = useState(25);
    

//     console.log("Start Date:", startDate);
//     console.log("End Date:", endDate);

//      const navigate=useNavigate()
//       const username = Cookies.get('username')
    
//       const checkuser = () => {
//         if (!username || username == null || username == undefined) {
//           navigate('/login')
//         }
//       }

//       useEffect(()=>{
//         checkuser()
//       },[])

//     const fetchData = async () => {
//         if (!startDate || !endDate) {
//             alert("Please select both start and end dates");
//             return;
//         }

//         setLoading(true);
//         setSubmitted(true);
//         try {
//             const response = await axios.get(`${baseURL}/api/v1/subscription`, {
//                 params: {
//                     startDate: startDate,
//                     endDate: endDate,
//                     serviceName : 'MyKidzHub',
//                 },
//             });
            
//             console.log('API Response Data:', response.data);
//             console.log('API Response Status:', response.status);

//             setDrawWinner(response.data);
//             console.log('Updated drawWinner state:', response.data);
//         } catch (error) {
//             console.error("Error fetching data:", error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleSubmit = (e) => {
//         e.preventDefault();
//         fetchData();
//     };

//     const formatDate = (date, isEndDate = false) => {
//         if (!date) return '';
//         const time = isEndDate ? '23:59:59' : '00:00:00';
//         const formatted = dayjs(date).format('YYYY-MM-DD') + ` ${time}`;
//         console.log('Formatted Date:', formatted);
//         return formatted;
//     };

//     const downloadExcel = () => {
//         const worksheet = XLSX.utils.json_to_sheet(drawWinner);
//         const workbook = XLSX.utils.book_new();
//         XLSX.utils.book_append_sheet(workbook, worksheet, "SubscriptionData");
//         XLSX.writeFile(workbook, "SubscriptionData.xlsx");
//     };


//     return (
//         <Layout>
//             <div className="">
//                 <div className="flex justify-between">
//                     <span className="font-semibold text-lg text-black">Subscription</span>
//                 </div>
//             </div>

//             <div className="flex justify-center items-center mt-3">
//                 <form onSubmit={handleSubmit} className="flex flex-col lg:flex-row gap-6 items-center bg-gray-100 p-6 rounded-lg  shadow-lg w-full max-w-2xl">
//                     <LocalizationProvider dateAdapter={AdapterDayjs}>
//                         <div className="flex flex-col lg:flex-row gap-4 w-full">
//                         <div className="w-full">
//                                 <label>Select Service</label>
//                                 <DatePicker
//                                     value={startDate ? dayjs(startDate) : null}
//                                     onChange={(newValue) => {
//                                         const formattedDate = formatDate(newValue);
//                                         console.log('Selected Start Date:', formattedDate);
//                                         setStartDate(formattedDate);
//                                     }}
//                                     format="YYYY-MM-DD"
//                                     className="w-full"
//                                 />
//                             </div>
//                             <div className="w-full">
//                                 <label>Start Date</label>
//                                 <DatePicker
//                                     value={startDate ? dayjs(startDate) : null}
//                                     onChange={(newValue) => {
//                                         const formattedDate = formatDate(newValue);
//                                         console.log('Selected Start Date:', formattedDate);
//                                         setStartDate(formattedDate);
//                                     }}
//                                     format="YYYY-MM-DD"
//                                     className="w-full"
//                                 />
//                             </div>
//                             <div className="w-full">
//                                 <label>End Date</label>
//                                 <DatePicker
//                                     value={endDate ? dayjs(endDate) : null}
//                                     onChange={(newValue) => {
//                                         const formattedDate = formatDate(newValue, true);
//                                         console.log('Selected End Date:', formattedDate);
//                                         setEndDate(formattedDate);
//                                     }}
//                                     format="YYYY-MM-DD"
//                                     className="w-full"
//                                 />
//                             </div>
//                         </div>
//                     </LocalizationProvider>

//                     <button type="submit" className="bg-blue-500 lg:mt-6 text-white p-2 rounded hover:bg-blue-400">
//                         Submit
//                     </button>
//                 </form>
//             </div>

//             {loading && <div className="flex justify-center items-center w-full mt-10 lg:mt-4 ">
//                 <Lottie animationData={loaderAnimation} style={{ width: 200, height: 200 }} />
//             </div>}

//             {!loading && submitted && drawWinner.length === 0 && <p className="text-center text-red-500 mt-10 ">No Data Found</p>}


//             {!loading && drawWinner.length > 0 && (
//                 <div className="overflow-x-auto mt-10 py-4">

                
//                      <div className="flex justify-end mb-4">
                     

//                         <button onClick={downloadExcel} className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-400">
//                             Download
//                         </button>
//                     </div>
//                     <TreeTable  className="w-[400px] sm:w-[660px] md:w-[790px] lg:w-[980px]"

//                         value={drawWinner.map((item, index) => ({
//                             key: index.toString(),
//                             data: { ...item, serialNumber: index + 1 }
//                             // data: item
//                         }))}
//                         paginator
//                         rowsPerPageOptions={[25, 50,75,100]}
//                         rows={rows}
//                     >
//                        <Column field="serialNumber" header="S.No" style={{ width: "60px" }}
//                        body={(rowData) => rowData.data.serialNumber}></Column>

//                         <Column field="date" header="Date"></Column>
//                         <Column field="dailySubscription" header="Daily Subscription"></Column>
//                         <Column field="weeklySubscription" header="Weekly Subscription"></Column>
//                         <Column field="monthlySubscription" header="Monthly Subscription"></Column>
//                         <Column field="ussd" header="USSD"></Column>
//                         <Column field="web" header="WEB"></Column>
//                         <Column field="total" header="Total"></Column>
//                     </TreeTable>
//                 </div>
//             )}
//         </Layout>
//     );
// };

// export default Dashboard;

